import { useLocation } from 'react-router-dom'
import { Tabs } from 'todistukset-ui/src/vtj/components/tab-navigation/todistus-tabs.enum'
import { tabConfig } from 'todistukset-ui/src/vtj/components/tab-navigation/tab-config'
import { TabComponentConfig } from 'todistukset-ui/src/vtj/components/tab-navigation/tab-navigation.types'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import { useTranslation } from 'react-i18next'

const resolveIsInfoTabActive = (pathname: string): boolean =>
  pathname.includes(Tabs.INFO)

const resolveIsMyCertificatesTabActive = (pathname: string): boolean =>
  pathname.includes(Tabs.MY_CERTIFICATES)
const resolveIsContentTabActive = (pathname: string): boolean =>
  !resolveIsInfoTabActive(pathname) &&
  !resolveIsMyCertificatesTabActive(pathname)
const getContentUrl = (pathname: string) => {
  if (resolveIsContentTabActive(pathname)) {
    // Add trailing slash if it's not there
    return pathname.match(/\/$/) ? pathname : `${pathname}/`
  }
  // Replace /lisatiedot/ (with or without trailing slash) with a simple trailing slash
  const regex = new RegExp(
    `/(?:${tabConfig[Tabs.INFO].path}|${
      tabConfig[Tabs.MY_CERTIFICATES].path
    })/?`
  )

  return pathname.replace(regex, '/')
}

const getInfoUrl = (pathname: string, contentUrl: string) => {
  if (resolveIsInfoTabActive(pathname)) {
    return pathname
  }

  return `${contentUrl}${tabConfig[Tabs.INFO].path}/`
}

const getMyCertificatesUrl = (pathname: string, contentUrl: string) => {
  if (resolveIsMyCertificatesTabActive(pathname)) {
    return pathname
  }

  return `${contentUrl}${tabConfig[Tabs.MY_CERTIFICATES].path}/`
}

export const useResolveTodistuksetTabs = (): TabComponentConfig[] => {
  const store = useStore()
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const isContentTabActive = resolveIsContentTabActive(pathname)
  const isInfoTabActive = resolveIsInfoTabActive(pathname)
  const isMyCertificatesTabActive = resolveIsMyCertificatesTabActive(pathname)
  const contentUrl = getContentUrl(pathname)
  const infoUrl = getInfoUrl(pathname, contentUrl)
  const myCertificatesUrl = getMyCertificatesUrl(pathname, contentUrl)
  const isLoggedIn = !!store.common.user

  return [
    {
      id: Tabs.CONTENT,
      to: contentUrl,
      isActive: isContentTabActive,
      label: t(tabConfig[Tabs.CONTENT].labelKey),
      isVisible: true,
    },
    {
      id: Tabs.INFO,
      to: infoUrl,
      isActive: isInfoTabActive,
      label: t(tabConfig[Tabs.INFO].labelKey),
      isVisible: true,
    },
    {
      id: Tabs.MY_CERTIFICATES,
      to: myCertificatesUrl,
      isActive: isMyCertificatesTabActive,
      label: t(tabConfig[Tabs.MY_CERTIFICATES].labelKey),
      certificateCount:
        store.previousOrders.length +
        store.aetStore.aetOrders.length +
        store.uaetOrders.length,
      isVisible: isLoggedIn,
    },
  ]
}
